 
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
document.addEventListener('DOMContentLoaded', function() {
    // Находим контейнер с новостями и кнопку
    const newsGrid = document.querySelector('.news-grid');
    const moreBlock = document.querySelector('.news-more.more');
    
    if (!newsGrid || !moreBlock) return; // Если элементов нет — выходим

    // Получаем все дочерние элементы-карточки (новости)
    const newsItems = Array.from(newsGrid.children).filter(child => child.nodeType === 1);
    if (newsItems.length === 0) return;

    // Количество новостей, загружаемых за один клик (из data-count)
    let itemsPerLoad = parseInt(moreBlock.dataset.count) || 6;
    let currentCount = itemsPerLoad; // Изначально показываем столько же

    // Функция для скрытия всех новостей, кроме первых currentCount
    function updateVisibility() {
        newsItems.forEach((item, index) => {
            if (index < currentCount) {
                item.classList.remove('hidden');   // показываем
            } else {
                item.classList.add('hidden');      // скрываем
            }
        });
    }

    // Функция для проверки, нужно ли скрыть кнопку
    function toggleMoreButton() {
        const hiddenCount = newsItems.filter(item => item.classList.contains('hidden')).length;
        const button = moreBlock.querySelector('.more__btn');
        if (hiddenCount === 0) {
            // Все новости показаны — убираем кнопку или отключаем
            moreBlock.style.display = 'none';
        } else {
            moreBlock.style.display = '';
        }
    }

    // Обработчик клика на кнопку
    const loadMoreBtn = moreBlock.querySelector('.more__btn');
    if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', function(e) {
            e.preventDefault();
            // Увеличиваем количество отображаемых элементов
            currentCount += itemsPerLoad;
            if (currentCount > newsItems.length) currentCount = newsItems.length;
            updateVisibility();
            toggleMoreButton();
        });
    }

    // Инициализация: добавляем класс hidden всем лишним, показываем первые currentCount
    // Сначала добавляем класс hidden всем (на всякий случай), потом убираем у нужных
    newsItems.forEach(item => item.classList.add('hidden'));
    updateVisibility();
    toggleMoreButton();
});   
document.querySelectorAll('.promo-slider').forEach((item)=>{

	const swiper = new Swiper(item.querySelector('.promo-slider__slider'), {
		navigation: {
			nextEl: item.querySelector('.nav__next'),
			prevEl:item.querySelector( '.nav__prev'),
		},
		spaceBetween: 10,
		slidesPerView: 1, 
		loop: true,
		effect: 'slide',
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 10
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 10
			}
		}
	})
})
 